(function() {
    'use strict';

    angular.module('process')
        .controller('ProcessListController', ProcessListController);

    ProcessListController.$inject = ['$state', 'processDataSrvc', 'processSrvc', 'notificationSrvc', 'processMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'processPermissionsConst', 'filterQuerySrvc'];

    function ProcessListController($state, processDataSrvc, processSrvc, notificationSrvc, processMessagesConst, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, processPermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.processRows = [];
        self.processCols = [{
            title: 'Opis',
            value: 'description',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = processPermissionsConst;
        self.searchQuery = {
            description: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getProcess();
        }

        function getProcess(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    description: self.searchQuery.description,
                    ordering: self.searchQuery.ordering
                };
            }
            return processDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.processRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getProcess);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.process.create');
        }

        function onEdit(row) {
            $state.go('layout.process.update', { pk: row.pk });
        }

        function onDelete(row) {
            return processSrvc.remove(row.description, row.pk, function(response) {
                notificationSrvc.notification("success", processMessagesConst.delete);
                lodashService.remove(self.processRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getProcess();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getProcess();
        }
    }
})();
